import * as net from '../net';

const PartsDAO = {};

PartsDAO.create_part_request = (data) => net.post({url: '/api/parts', data});

PartsDAO.get_part_request = (part_request_id) => net.get({url: `/api/parts/${part_request_id}`});

export default PartsDAO;
